/**
 * Where quotes open (#6274 Q9). A light module so pages outside Quoting (the ticket page, Projects) can link to the
 * worksheet without loading it.
 */

/** The one-page quote worksheet: a new quote, or `?draftId=` to reopen a saved one. */
export const WORKSHEET_PATH = '/quoting/worksheet';

/** The old Create Quote address. Every Create Quote button goes here; with the worksheet on it forwards to the worksheet. */
export const QUOTE_CREATE_PATH = '/quoting/quotes/create';

/** A saved quote's own page (read-only for a worksheet quote while the worksheet is off). */
export function quoteDetailPath(quoteId: string): string {
  return `/quoting/quotes/${encodeURIComponent(quoteId)}`;
}

/** A saved worksheet quote, reopened in the worksheet. */
export function worksheetDraftPath(quoteId: string): string {
  return `${WORKSHEET_PATH}?draftId=${encodeURIComponent(quoteId)}`;
}

/** The status a quote not yet completed carries (QuoteStatus 'Draft'). */
export const DRAFT_QUOTE_STATUS = 'Draft';

/** Where a link to an existing quote goes: a Draft reopens in the worksheet to be finished; any other quote opens its own page. */
export function existingQuotePath(quoteId: string, status?: string): string {
  return status === DRAFT_QUOTE_STATUS ? `${QUOTE_CREATE_PATH}?draftId=${encodeURIComponent(quoteId)}` : quoteDetailPath(quoteId);
}
